import { render, staticRenderFns } from "./ybVipClientList.vue?vue&type=template&id=2372148a&scoped=true&"
import script from "./ybVipClientList.vue?vue&type=script&lang=js&"
export * from "./ybVipClientList.vue?vue&type=script&lang=js&"
import style0 from "./ybVipClientList.vue?vue&type=style&index=0&id=2372148a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372148a",
  null
  
)

export default component.exports